<sbnb-apps-detail-page
  vendorCode="chargeautomation"
  name="ChargeAutomation"
  logoTile="/assets/images/apps/chargeautomation-logo.svg"
  builtBy="ChargeAutomation"
  builtByLink="https://app.chargeautomation.com/register?utm_source=Hospitable&utm_campaign=Partners"
  [categories]="['Guest portal']"
  [permissions]="[AppPermission.calendarRead, AppPermission.propertyListingRead, AppPermission.reservationRead]"
  email="support@chargeautomation.com"
  [helpArticles]="[
    {
      id: '8018518',
      title: 'How to integrate Hospitable with Charge Automation'
    }
  ]">
  <ng-container description>
    <p>
      ChargeAutomation's Guest Experience Platform is the key to streamlining check-ins and increasing revenue while
      elevating your guest's experience and reducing your workload.
    </p>

    <p>Create a single & streamlined workflow to collect...</p>

    <ul class="list list__looser">
      <li>Pre-arrival info (ID, Selfie, E-signature, T&Cs, etc)</li>
      <li>Rental Agreements</li>
      <li>Payment & Security Deposit</li>
      <li>Upsell (Upgrades, Services, Tours ...etc)</li>
      <li>Guest Portal (Guidebook, Upsell, Chat, Smartlock)</li>
      <li>Connection to 120+ Payment Gateways</li>
      <li>100% Chargeback Protection</li>
    </ul>

    <p>
      ChargeAutomation's 1-way connection allows Hospitable to push all your reservations to your ChargeAutomation
      account automatically.
    </p>

    <p>Get started for FREE with ChargeAutomation today!</p>
  </ng-container>

  <sbnb-image-carousel
    [images]="[
      '/assets/images/apps/charge-automation/chargeautomation-1.png',
      '/assets/images/apps/charge-automation/chargeautomation-2.jpeg',
      '/assets/images/apps/charge-automation/chargeautomation-3.png'
    ]"></sbnb-image-carousel>
</sbnb-apps-detail-page>
